































export default {
  name: 'epb-textbox',
  computed: {
    inputWrapperClasses: function (): string[] {
      const classes = [
        `epb-textbox__input-wrapper--${ this.color }`
      ];

      if (this.disabled) {
        classes.push('epb-textbox__input-wrapper--disabled');
      }
      if (this.hovered) {
        classes.push('epb-textbox__input-wrapper--hover');
      }
      if (this.focused) {
        classes.push('epb-textbox__input-wrapper--focused');
      }
      if (!this.valid) {
        classes.push('epb-textbox__input-wrapper--invalid');
      }

      return classes;
    }
  },
  data: function () {
    return {
      focused: false,
      hovered: false
    };
  },
  props: {
    value: String,
    type: {
      type: String, // text, password TODO: textarea
      default: 'text'
    },
    color: {
      type: String,
      default: 'primary'
    },
    label: String,
    placeholder: String,
    help: String,
    error: String,
    valid: {
      type: Boolean,
      default: true
    },
    icon: String,
    iconPosition: { // left, right
      type: String,
      default: 'right'
    },
    disabled: Boolean
  }
};
